<template>
    <div>
        <div v-if="!!mails"> 
            <v-badge color="primary" overlap bordered offset-y="9" offset-x="9">
                <template v-slot:badge>
                    <span>{{ mails }}</span> 
                </template>      
                <v-btn color="primary" small block v-on:click="showDialog(encrid)">  
                    <v-icon small style="minwidth: 0;">mdi-email-fast-outline</v-icon><span>&nbsp;e-mails</span>
                </v-btn>
            </v-badge>   
        </div>   
        <div v-else>
            <v-btn small block :disabled="!!mails" elevation="0" v-on:click="showDialog(encrid)">  
                <v-icon small style="minwidth: 0;">mdi-email-fast-outline</v-icon><span>&nbsp;e-mails</span>
            </v-btn>
        </div>    
    </div>
</template>

<script>
    export default {    
        props: {
            mails: {
                type: Number,
                default: 0
            },
            encrid: {
                type: String,
                default: ''
            },    
        },
        methods: {
            showDialog(encrid){
                this.$emit('showDialog', encrid);
            },
        }
    }
</script>

<style scoped>

</style>